var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExplore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z",
  vectorEffect: "non-scaling-stroke"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.833 3.833H4.417A1.917 1.917 0 0 0 2.5 5.75v13.416c0 1.059.858 1.917 1.917 1.917h13.416a1.917 1.917 0 0 0 1.917-1.917V5.75a1.917 1.917 0 0 0-1.917-1.917",
  vectorEffect: "non-scaling-stroke"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.833 3.833H4.417A1.917 1.917 0 0 0 2.5 5.75v3.833h17.25V5.75a1.917 1.917 0 0 0-1.917-1.917M14.957 1.917V5.75M7.293 1.917V5.75",
  vectorEffect: "non-scaling-stroke"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.875 24a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
  vectorEffect: "non-scaling-stroke"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.875 21.733a6.233 6.233 0 1 0 0-12.467 6.233 6.233 0 0 0 0 12.467",
  vectorEffect: "non-scaling-stroke"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m22 22-2-2",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgExplore;